import "../styles/LanguageSelector.scss"
import { useSelector, useDispatch } from "react-redux"
import React, { useEffect, useState } from "react";
import imageFR from "../images/FR.png"
import imageEN from "../images/EN.png"


function LanguageSelector() {

    const dispatch = useDispatch();
    const storeLanguage = state => state.language;

    const currentLanguage = useSelector(storeLanguage);


    return  <div className = "language-selector__icons">
                <img src={imageFR} alt='Parachutisme' className='' onClick = { () => {
                    dispatch({ type: 'language/ChangeValue', payload: 'FR' })
                    }}/>
                
                <img src={imageEN} alt="" className='' onClick = { () => {
                    dispatch({ type: 'language/ChangeValue', payload: 'EN' })
                    }}/>

                
            </div>
  }
export default LanguageSelector
